import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  assignLeadToUser,
  bulkUploadLeads,
  createLead,
  deleteLead,
  getAllLeads,
  getLeadByID,
  updateLead,
  updateLeadStageStatus,
} from "./services/lead.services";
import { ILeadInitialState } from "./leadModel";

const initialState: ILeadInitialState = {
  loading: false,
  bulkUploadLoading: false,
  formLoading: false,
  error: "",
  activeTabIndex: 0,
  LeadList: [],
  LeadStageCounts: {
    OverallLeads: null,
    TotalNew: null,
    TotalCallback: null,
    TotalUnassigned: null,
  },
  LeadID: null,
  LeadStageID: null,
  LeadDetails: {
    Initial: "",
    FirstName: "",
    LastName: "",
    CountryCode: "",
    MobileNo: "",
    EmailID: "",
    LeadSourceID: null,
    LeadStageID: 1,
  },
  LeadFilterDetails: {
    filterLeadStageID: 1 || null,
    filterLeadSourceID: null,
    filterName: "",
    filterMobileNo: "",
    filterEmailID: "",
    filterAssignedTo: null,
    filterUnassignedLeads: false,
    filterFromDate: "",
    filterToDate: "",
    filterContactID: "",
  },
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    clearLeadDetails: (state) => {
      state.LeadDetails = initialState.LeadDetails;
    },
    setLeadID: (state, action) => {
      state.LeadID = action.payload;
    },
    clearLeadID: (state) => {
      state.LeadID = initialState.LeadID;
    },
    setLeadStageID: (state, action) => {
      state.LeadStageID = action.payload;
    },
    clearLeadStageID: (state) => {
      state.LeadStageID = initialState.LeadStageID;
    },
    setactiveTabIndex: (state, action) => {
      state.activeTabIndex = action.payload;
    },
    setLeadFilterDetails: (state, action) => {
      state.LeadFilterDetails = action.payload;
    },
    clearLeadFilterDetails: (state) => {
      state.LeadFilterDetails = initialState.LeadFilterDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllLeads.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllLeads.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.LeadList = action.payload?.LeadsList || [];
        state.LeadStageCounts.TotalNew = action.payload?.TotalNew || null;
        state.LeadStageCounts.TotalCallback =
          action.payload?.TotalCallback || null;
        state.LeadStageCounts.OverallLeads =
          action.payload?.OverallLeads || null;
        state.LeadStageCounts.TotalUnassigned =
          action.payload?.TotalUnassigned || null;
      }
    );
    builder.addCase(getAllLeads.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LeadList = [];
      state.LeadStageCounts.TotalNew = null;
      state.LeadStageCounts.TotalCallback = null;
      state.LeadStageCounts.OverallLeads = null;
      state.LeadStageCounts.TotalUnassigned = null;
    });

    builder.addCase(createLead.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createLead.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createLead.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateLead.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateLead.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateLead.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteLead.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteLead.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getLeadByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getLeadByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.LeadDetails = action.payload;
    });
    builder.addCase(getLeadByID.rejected, (state, action) => {
      state.formLoading = false;
      state.LeadDetails = initialState.LeadDetails;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(assignLeadToUser.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(assignLeadToUser.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(assignLeadToUser.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateLeadStageStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateLeadStageStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateLeadStageStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(bulkUploadLeads.pending, (state) => {
      state.bulkUploadLoading = true;
      state.error = "";
    });
    builder.addCase(bulkUploadLeads.fulfilled, (state) => {
      state.bulkUploadLoading = false;
    });
    builder.addCase(bulkUploadLeads.rejected, (state, action) => {
      state.bulkUploadLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearLeadDetails,
  setactiveTabIndex,
  clearLeadID,
  setLeadID,
  setLeadStageID,
  clearLeadStageID,
  setLeadFilterDetails,
  clearLeadFilterDetails,
} = leadSlice.actions;
export default leadSlice.reducer;
